import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import StudentGrades from './StudentGrades';
import AdminGrades from './AdminGrades';
import { AuthDebug } from '../common';

const GradeRouter = () => {
  const { user, isAuthenticated, isAdmin } = useAuth();

  const normalizeRoleName = (role) => {
    const raw = typeof role === 'string' ? role : role?.name || role?.authority;
    if (!raw || typeof raw !== 'string') return '';
    return raw.toUpperCase().replace(/^ROLE_/, '');
  };

  // Show debug info for troubleshooting
  // TODO: Remove this after fixing authentication
  if (window.location.search.includes('debug')) {
    return <AuthDebug />;
  }

  // Check if user is logged in
  if (!isAuthenticated || !user) {
    return (
      <div className="container-fluid p-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading user data...</p>
          <div className="mt-3">
            <small className="text-muted">
              Having trouble? <a href="/grades?debug">View debug info</a>
            </small>
          </div>
        </div>
      </div>
    );
  }

  // Check if user has roles
  const userRoles = user.roles || [];
  const hasLernendeRole = userRoles.some((role) => {
    const normalized = normalizeRoleName(role);
    return normalized === 'LERNENDE' || normalized === 'STUDENT';
  });
  
  // Route based on user role - Admin takes precedence
  if (isAdmin()) {
    return <AdminGrades />;
  } else if (hasLernendeRole) {
    return <StudentGrades />;
  } else {
    // Default to student view for users without specific roles
    return <StudentGrades />;
  }
};

export default GradeRouter;